"use client";

import { Button } from "../ui/button";
import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowRight02Icon, Share08Icon } from "@hugeicons/core-free-icons";
import { toast } from "sonner";
import { useRouter } from "next/navigation";

export function MobileControls() {
  const router = useRouter();

  return (
    <>
      <Button
        onClick={() => {
          if (navigator.share) {
            navigator.share({
              url: decodeURIComponent(window.location.href),
            });
          } else {
            navigator.clipboard.writeText(
              decodeURIComponent(window.location.href)
            );
            toast.success("آدرس با موفقیت کپی شد.");
          }
        }}
        variant="pill"
        className="absolute top-3 left-4 z-10 size-11"
      >
        <HugeiconsIcon
          icon={Share08Icon}
          className="size-5"
          strokeWidth={1.5}
        />
      </Button>
      <Button
        onClick={() => {
          router.back();
        }}
        variant="pill"
        className="absolute top-3 right-4 z-10 size-11"
      >
        <HugeiconsIcon
          icon={ArrowRight02Icon}
          className="size-6 text-black-500"
          strokeWidth={1.5}
        />
      </Button>
    </>
  );
}
